import React, { FunctionComponent } from 'react'
import styles from './StatisticsCapture.module.scss'
import SideMark from '../../../etc/SideMark/SideMark'
import { Colors } from '../../../../styles'
import Spacer from '../../../etc/Spacer'
import Button from '../../../controls/Button/Button'
import DownLoad from '../../../../../files/download.svg'
import { useRootSelector } from '../../../../utils/hooks'
import { isDefinedTuple, pick } from '../../../../utils/utils'
import { fst, snd } from 'fp-ts/Tuple'
import { pipe } from 'fp-ts/function'
import { toReadableDateString } from '../../../../utils/date-utils'

const StatisticsCapture : FunctionComponent = ()=> {
    const {date} = useRootSelector(state => pick(state.pages.statistics.byClient, 'date'))

    return <div className={styles.capture}>
        <SideMark color={Colors.blue}/>
        <Spacer/>
        <div className={styles.info}>
            <p>В период: <span>{isDefinedTuple(date) && pipe(date, fst, toReadableDateString)}</span></p>
            <p>по: <span>{isDefinedTuple(date) && pipe(date, snd, toReadableDateString)}</span></p>
        </div>
        <Button
            title={'Выгрузить в Exel'}
            // onClick={props.onClear}
        >
            <DownLoad/>
        </Button>
    </div>
}
export default StatisticsCapture